import { render, staticRenderFns } from "./OrderBook.vue?vue&type=template&id=6ca4dfd4&scoped=true&"
import script from "./OrderBook.vue?vue&type=script&lang=js&"
export * from "./OrderBook.vue?vue&type=script&lang=js&"
import style0 from "./OrderBook.vue?vue&type=style&index=0&id=6ca4dfd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca4dfd4",
  null
  
)

export default component.exports